// en, de, fr, pt
export default {
  pl: {
    MyAccount: 'Moje konto',
    eCommerce: 'eCommerce',
    Apps: 'Aplikacje',
    Todo: 'Todo',
    Chat: 'Czat',
    Email: 'Email',
    Calendar: 'Kalendarz',
    FullCalendar: 'Pełen kalendarz',
    SimpleCalendar: 'Prosty kalendarz',
    Shop: 'sklep',
    ItemDetails: 'Szczegóły produktu',
    Cart: 'karta',
    WishList: 'Wish List',
    Checkout: 'Sprawdzić',
    UI: 'UI',
    DataList: 'Wykaz danych',
    ListView: 'Podgląd listy',
    ThumbView: 'Thumb View',
    Grid: 'Siatka',
    Vuexy: 'Vuexy',
    Vuesax: 'Vuesax',
    Tailwind: 'Tailwind',
    Colors: 'kolory',
    Card: 'karta',
    Basic: 'prosty',
    Statistics: 'statystyki',
    Analytics: 'Analityka',
    CardActions: 'Karty akcji',
    CardColors: 'Kolory kart',
    Table: 'Table',
    agGridTable: 'agGrid Table',
    Components: 'Komponenty',
    Alert: 'Alarm',
    Avatar: 'Awatar',
    Badge: 'odznaka',
    Breadcrumb: 'Breadcrumb',
    Button: 'przycisk',
    ButtonGroup: 'grupa przycisków',
    Chip: 'Chip',
    Collapse: 'Collapse',
    Dialogs: 'Dialogs',
    Divider: 'Divider',
    DropDown: 'DropDown',
    List: 'Lista',
    Loading: 'Logowanie',
    Navbar: 'Pasek nawigacji',
    Notifications: 'Powiadomienia',
    Pagination: 'Stronnicowanie',
    Popup: 'Pop-up',
    Progress: 'Progres',
    Sidebar: 'Pasek boczny',
    Slider: 'Slajder',
    Tabs: 'Zakładki',
    Tooltip: 'Etykieta',
    Upload: 'Załadować dane',
    FormsAndTable: 'Formularze i tabele',
    FormElements: 'Elementy formularzy',
    Select: 'wybrać',
    Switch: 'Przełącznik',
    Checkbox: 'Pole wyboru',
    Radio: 'Radio',
    Input: 'Wejście',
    NumberInput: 'typ wejścia',
    Textarea: 'Pole tekstowe',
    FormLayouts: 'Format Layouts',
    FormWizard: 'Format kreatora',
    FormValidation: 'FormValidation',
    FormInputGroup: 'Form Input Group',
    Pages: 'Strony',
    Authentication: 'Uwierzytelnienie',
    Login: 'Login',
    Register: 'Rejestracje',
    ForgotPassword: 'Zapomniałem hasła',
    ResetPassword:'Resetowanie hasła',
    LockScreen: 'Ekran blokady',
    Miscellaneous: 'Miscellaneous',
    ComingSoon: 'Wkrótce',
    Error: 'Błąd',
    404: '404',
    500: '500',
    NotAuthorized: 'nieuwierzytelniony',
    Maintenance: 'utrzymanie',
    Profile: 'Profil',
    User: 'Użytkownik',
    View: 'Widok',
    Edit: 'Edycja',
    UserSettings: 'Ustawienia użytkownika',
    Invoice: 'faktura',
    FAQ: 'FAQ',
    Search: 'szukać',
    KnowledgeBase: 'Baza wiedzy',
    ChartsAndMaps: 'Wykresy i mapy',
    Charts: 'wykresy',
    ApexCharts: 'Apex Charts',
    chartjs: 'chartjs',
    echarts: 'echarts',
    chartist: 'chartist',
    GoogleMap: 'Google Map',
    Extensions: 'rozszerzenia',
    QuillEditor: 'Quill Edytor',
    DragAndDrop: 'Przeciągnij i upuść',
    Datepicker: 'Datepicker',
    DatetimePicker: 'Rozwijane menu',
    AccessControl: 'Kontrola dostępu',
    I18n: 'I18n',
    Carousel: 'Carousel',
    Clipboard: 'schowek',
    ContextMenu: 'Menu kontekstowe',
    StarRatings: 'Ocena',
    Autocomplete: 'Autouzupełnianie',
    Tree: 'Tree',
    // "Import/Export": 'Import/Eksport',
    Import: 'Import',
    Export: 'Eksport',
    ExportSelected: 'Eksportuj wybrane',
    Others: 'Inne',
    MenuLevels: 'Poziom menu',
    MenuLevel2p1: 'Poziom menu 2.1',
    MenuLevel2p2: 'Poziom menu 2.2',
    MenuLevel3p1: 'Poziom menu 3.1',
    MenuLevel3p2: 'Poziom menu 3.2',
    DisabledMenu: 'Wyłączone Menu',
    Support: 'Wsparcie',
    Documentation: 'Dokumenctacja',
    RaiseSupport: 'Raise Support',
    demoTitle: 'Tytuł karty',
    demoText: 'Cake sesame snaps cupcake gingerbread danish I love gingerbread. Apple pie pie jujubes chupa chups muffin halvah lollipop. Chocolate cake oat cake tiramisu marzipan sugar plum. Donut sweet pie oat cake dragée fruitcake cotton candy lemon drops.',

    Dashboard: 'Strona główna',
    Trainings: 'Szkolenia',
    Certs: 'Certyfikaty',
    Help: 'Pomoc',
    Administration: 'Administracja',
    Agreements: 'Zgody i klauzule',
    Settings: 'Ustawienia',
    Users: 'Użytkownicy',
    Lessons: 'Moduły',
    Exams: 'Egzaminy',
    Reports: 'Raporty',
  },
}
